module.exports = __webpack_public_path__ + "img/iotech_logo.faafcf52.png";